import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/Service/auth.service';

@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrls: ['./thankyou.component.css'],
    standalone: false
})
export class ThankyouComponent {
  remainingTime: number = 15;
  id: string;
  thankyoupop;
  subscriptions: Subscription = new Subscription();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.startTimer();
    this.subscriptions.add(
      this.route.paramMap.subscribe((params) => {
        this.id = params.get('id');
        if (this.id) {
          this.auth
            .NewsLetterConfirmation(this.id, { emailConfirmed: true })
            .subscribe((res) => {
              this.thankyoupop = res;
            });
        }
      })
    );
  }

  startTimer() {
    setInterval(() => {
      this.remainingTime--;
      if (this.remainingTime == 0) {
        this.router.navigate(['/']);
      }
    }, 1000);
  }
}
